import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';

import FormInput from '../forms/FormInput';
import FaQuestionCircle from 'react-icons/lib/fa/question-circle';

import ImageContainer from '../image-handler/ImageContainer';
import {cleanTextInput, findElement} from "../../utils/helpers";

class Step6 extends Component {
    render() {
        return (
            <div className='wt-step-6 step-content'>
                <div className='row'>
                    <h5 className='col s6' >
                        {this.props.translate('KRW.stepSix.menu.title')}
                    </h5>
                </div>
                <div className='col s12'>
                    <div className='row' style={{marginBottom: '10px'}}>
                        <div className='col l12 s12' style={{padding: 0}}>
                            <div className='col l2'>
                                <div style={{paddingTop: '10px'}}>{this.props.translate('KRW.stepSix.form.left')}</div>
                            </div>
                            <div className='col l1'>
                                <FormInput
                                    type='checkbox'
                                    name='KRW.GK81'
                                    divClass='col s12 m4 l1'
                                    value={this.props.krw.GK81.CurrentValue}
                                    checked={this.props.krw.GK81.CurrentValue === '1'}
                                />
                            </div>
                            <div className='col l1 offset-l4'>
                                <div style={{paddingTop: '10px'}}>{this.props.translate('KRW.stepSix.form.right')}</div>
                            </div>
                            <FormInput
                                type='checkbox'
                                name='KRW.GK45'
                                divClass='col s12 m4 l1'
                                value={this.props.krw.GK45.CurrentValue}
                                checked={this.props.krw.GK45.CurrentValue === '1'}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col l12 s12' style={{padding: 0}}>
                            <div className='col l2'>
                                <div style={{paddingTop: '10px'}}>{this.props.translate('KRW.stepSix.form.measure')}:</div>
                            </div>
                            <FormInput
                                type='number'
                                fieldStyle={{marginLeft: '15px'}}
                                name='KRW.GKM81'
                                value={this.props.krw.GKM81.CurrentValue}
                                divClass='col s4 m4 l2'
                                min={parseInt(findElement(this.props.krw.GKM81.Values.Range, 'StepSize').LowerLimit)}
                                max={parseInt(findElement(this.props.krw.GKM81.Values.Range, 'StepSize').UpperLimit)}
                                subLabel={`${findElement(this.props.krw.GKM81.Values.Range, 'StepSize').LowerLimit} - ${findElement(this.props.krw.GKM81.Values.Range, 'StepSize').UpperLimit}`}
                                disabled={this.props.krw.GK81.CurrentValue !== '1'}
                            />
                            <FormInput
                                type='number'
                                fieldStyle={{marginLeft: '15px'}}
                                name='KRW.GKM45'
                                value={this.props.krw.GKM45.CurrentValue}
                                divClass='col s4 m4 l2 offset-l4'
                                min={parseInt(findElement(this.props.krw.GKM45.Values.Range, 'StepSize').LowerLimit)}
                                max={parseInt(findElement(this.props.krw.GKM45.Values.Range, 'StepSize').UpperLimit)}
                                subLabel={`${findElement(this.props.krw.GKM45.Values.Range, 'StepSize').LowerLimit} - ${findElement(this.props.krw.GKM45.Values.Range, 'StepSize').UpperLimit}`}
                                disabled={this.props.krw.GK45.CurrentValue !== '1'}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <ImageContainer
                            image={this.props.image.Image}
                            name='krw'
                            divClass='col s12'
                            height='100%' />
                    </div>
                </div>
            </div>
        )
    }

}

/**
 * Prop types
 * @type {{tempDetails: *}}
 */
Step6.propTypes = {
    stepControl: PropTypes.func.isRequired,
    krw:     PropTypes.object,
    translate:   PropTypes.func.isRequired,
};

function mapStateToProps({krw, locale, image}) {
    return {
        krw,
        translate: getTranslate(locale),
        image,
    }
}


export default connect(mapStateToProps, actions)(Step6);



// WEBPACK FOOTER //
// ./src/components/krw-steps/Step6.js